// extracted by mini-css-extract-plugin
module.exports = {"icon":"theme__icon--1-mD4","link":"theme__link--1Od3D","active":"theme__active--3blKB"};